import { useState, type FormEvent } from "react";

const hotNames = [
  { name: "顾言泽", tag: "歌手", views: "18.2万" },
  { name: "桃桃酱", tag: "网红", views: "12.6万" },
  { name: "电竞KK", tag: "主播", views: "9.8万" },
  { name: "沈嘉茉", tag: "演员", views: "8.4万" },
  { name: "林岳", tag: "财经大V", views: "6.1万" },
];

export default function SearchHero() {
  const [kw, setKw] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!kw.trim()) return;
    setDone(true);
  };

  return (
    <section id="search" className="relative overflow-hidden bg-background-100">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-10 md:py-14 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-flashlight-line text-sm" />
            <span>想查谁，直接搜名字——档案都在这一页集中呈现</span>
          </div>
          <h2 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-[42px] md:leading-[1.15]">
            88黑料百科，
            <br />
            按人建档的
            <span className="text-primary-600">「瓜」</span>集中营
          </h2>
          <p className="mt-4 max-w-xl text-[15px] leading-7 text-foreground-600">
            这里不是一条条孤立爆料，而是把某位明星、网红、主播或公众人物背后的<b>事件背景、时间线、关联人物与补充说明</b>
            归档成可检索的档案。输入名字，黑料条目一次看完，前后对得上，才算吃明白。
          </p>

          {/* 检索 */}
          <form onSubmit={submit} className="mt-6 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:rounded-full sm:border sm:border-background-300 sm:bg-background-50 sm:p-1.5">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 sm:flex-1 sm:border-0 sm:bg-transparent sm:p-1">
              <i className="ri-search-line text-lg text-foreground-400" />
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="输入人物名字或外号，如：顾言泽"
                className="w-full bg-transparent py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 sm:py-2"
              />
            </div>
            <button
              type="submit"
              className="flex items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:py-2"
            >
              查他的档案
              <i className="ri-arrow-right-line" />
            </button>
          </form>
          {done && (
            <div className="mt-3 flex items-center gap-2 rounded-lg bg-accent-100 px-3 py-2 text-sm text-accent-900">
              <i className="ri-checkbox-circle-line" />
              <span>
                已按「{kw}」检索，共匹配 <b>3 条黑料档案</b>（示例页面，可继续输入其他名字体验）
              </span>
            </div>
          )}

          {/* 热搜 */}
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1 text-xs text-foreground-400">
              <i className="ri-fire-fill text-primary-500" /> 此刻正在搜
            </span>
            {hotNames.map((h) => (
              <button
                key={h.name}
                type="button"
                onClick={() => setKw(h.name)}
                className="whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                {h.name} · {h.tag}
              </button>
            ))}
          </div>
        </div>

        {/* 右侧围观信息卡 —— 社区氛围感 */}
        <div className="grid gap-4">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-foreground-950">此刻正在围观</h3>
              <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                <span className="relative flex h-1.5 w-1.5">
                  <span className="animate-live absolute inline-flex h-full w-full rounded-full bg-secondary-500" />
                  <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-secondary-500" />
                </span>
                <span>实时</span>
              </span>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-3 text-center">
              <div className="rounded-xl bg-background-100 px-2 py-3">
                <p className="font-heading text-xl font-bold text-primary-600">23,841</p>
                <p className="mt-0.5 text-xs text-foreground-500">正在检索</p>
              </div>
              <div className="rounded-xl bg-background-100 px-2 py-3">
                <p className="font-heading text-xl font-bold text-primary-600">1.2w+</p>
                <p className="mt-0.5 text-xs text-foreground-500">收藏的档案</p>
              </div>
              <div className="rounded-xl bg-background-100 px-2 py-3">
                <p className="font-heading text-xl font-bold text-accent-600">9,376</p>
                <p className="mt-0.5 text-xs text-foreground-500">今日围观</p>
              </div>
            </div>
            <div className="mt-4 space-y-2.5">
              {[
                { icon: "ri-quill-pen-line", text: "你手里有料？投稿帮你归档成册" },
                { icon: "ri-download-2-line", text: "下载 App，实时追更不发漏" },
                { icon: "ri-chat-smile-3-line", text: "到围观广场，跟同好一起对时间线" },
              ].map((r, i) => (
                <a
                  key={i}
                  href={i === 1 ? "#archive" : "#talk"}
                  className="flex items-center gap-3 rounded-xl border border-background-200 px-3 py-2.5 transition-colors hover:border-primary-300"
                >
                  <i className={`${r.icon} text-lg text-accent-600`} />
                  <span className="text-sm text-foreground-700">{r.text}</span>
                  <i className="ri-arrow-right-s-line ml-auto text-foreground-300" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}